import { NeuroConstants } from './neuro.constants'
import { INeuroState, INeuroAction } from './neuro.types'

export const neuroPrNabc = {
  headConciousness: null,
  strokeScale: null,
  strokeScalePNNV: null,
  strokescaleScore: null,
  strokeCvaSymptomsResolved: null,
  strokeCvaSymptomsResolvedPNNV: null,
  headLossCons: null,
  headFindings: '',
  chemParalyzed: 0,
  dtBaselineSeen: '',
  dtBaselineSeenPNNV: null,
  _toggleWasPtImmFlag: false,
}

export const _featureRefKey = 'neuro'

export const neuroPrAssess = {
  thromScreen: null,
  thromScreenPNNV: null,
}

export const neuroPrStrokeScale = []

export const initialNeuroState: INeuroState = {
  ...neuroPrNabc,
  ...neuroPrAssess,
  neuroPrStrokeScale,
}

export function neuroReducer(state: INeuroState = initialNeuroState, action: INeuroAction): INeuroState {
  switch (action.type) {
    case NeuroConstants.SET_HEADCONCIOUSNESS:
      return { ...state, headConciousness: action.headConciousness }
    case NeuroConstants.SET_STROKESCALE:
      return { ...state, strokeScale: action.strokeScale }
    case NeuroConstants.SET_STROKESCALEPNNV:
      return { ...state, strokeScalePNNV: action.strokeScalePNNV }
    case NeuroConstants.SET_STROKE_SCALE_ID:
      return { ...state, neuroPrStrokeScale: action.neuroPrStrokeScale }
    case NeuroConstants.SET_STROKE_SCALE_SCORE:
      return { ...state, strokescaleScore: action.strokescaleScore }
    case NeuroConstants.SET_STROKECVASYMPTOMSRESOLVED:
      return { ...state, strokeCvaSymptomsResolved: action.strokeCvaSymptomsResolved }
    case NeuroConstants.SET_STROKECVASYMPTOMSRESOLVEDPNNV:
      return { ...state, strokeCvaSymptomsResolvedPNNV: action.strokeCvaSymptomsResolvedPNNV }
    case NeuroConstants.SET_THROMSCREEN:
      return { ...state, thromScreen: action.thromScreen }
    case NeuroConstants.SET_THROMSCREENPNNV:
      return { ...state, thromScreenPNNV: action.thromScreenPNNV }
    case NeuroConstants.SET_HEADLOSSCONS:
      return { ...state, headLossCons: action.headLossCons }
    case NeuroConstants.SET_HEADFINDINGS:
      return { ...state, headFindings: action.headFindings }
    case NeuroConstants.SET_CHEMPARALYZED:
      return { ...state, chemParalyzed: action.chemParalyzed }
    case NeuroConstants.SET_DTBASELINESEEN:
      return { ...state, dtBaselineSeen: action.dtBaselineSeen }
    case NeuroConstants.SET_DTBASELINESEENPNNV:
      return { ...state, dtBaselineSeenPNNV: action.dtBaselineSeenPNNV }
    case NeuroConstants.SET_NEURO:
      return { ...state, ...action.neuroData }
    case NeuroConstants.RESET_NEURO_STATE:
      return { ...state, ...initialNeuroState }
    case NeuroConstants.TOGGLE_WAS_PATIENT_IMMOBILIZED:
      return { ...state, _toggleWasPtImmFlag: action._toggleWasPtImmFlag }
    default:
      return state
  }
}
